
import { useEffect } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { ProfileFormValues } from '../ProfileFormSchema';
import {
  FormField,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

// Belt colors options
const beltColors = [
  { value: 'white', label: 'White Belt' },
  { value: 'blue', label: 'Blue Belt' },
  { value: 'purple', label: 'Purple Belt' },
  { value: 'brown', label: 'Brown Belt' },
  { value: 'black', label: 'Black Belt' },
  { value: 'other', label: 'Other (Kids/Custom Belt)' },
];

type BeltSelectorProps = {
  control: Control<ProfileFormValues>;
  setShowCustomBelt: (show: boolean) => void;
};

export function BeltSelector({ control, setShowCustomBelt }: BeltSelectorProps) {
  const beltRank = useWatch({
    control,
    name: 'belt_rank',
    defaultValue: 'white',
  });

  // Update showCustomBelt state when belt_rank changes
  useEffect(() => {
    if (beltRank === 'other') {
      setShowCustomBelt(true);
    } else {
      setShowCustomBelt(false);
    }
  }, [beltRank, setShowCustomBelt]);

  return (
    <FormField
      control={control}
      name="belt_rank"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Belt Rank</FormLabel>
          <Select 
            onValueChange={(value) => {
              field.onChange(value);
              setShowCustomBelt(value === 'other');
            }}
            value={field.value || 'white'}
            defaultValue="white"
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select your belt color" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {beltColors.map((belt) => (
                <SelectItem key={belt.value} value={belt.value}>
                  {belt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
